import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_MENU_HOTELS,
	STR_MENU_MY_PURCHASES,
	STR_MY_WITHDRAWAL_REQUESTS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECENT_CROPS,
	STR_RECENT_ITEMS,
	STR_RECENT_REQUESTS,
	STR_SEARCH_HERE,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_MORE
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSearch, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import OneWithdrawalRequest from "../ones/OneWithdrawalRequest";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	const [filter, setFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getMyWithdrawalRequests(),
		])
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						
						<div className="col-md-12">
							
							<h6 className="main-section-title">
								{STR_MY_WITHDRAWAL_REQUESTS[appContext.language]} 
								<br/>
								({appContext.myWithdrawalRequests?.length})
							</h6>
								
						</div>

						<div className="col-md-12">
							
							

							{
								(appContext.myWithdrawalRequests && appContext.myWithdrawalRequests.length > 0) ?
								<>
									{
										appContext.myWithdrawalRequests.map((item, i) => {
											return (
												<OneWithdrawalRequest
													data={item}
													key={i}
												/>
											)
										})
									}
									
								</>
								:
								<h6>
									{STR_NO_RECORD[appContext.language]}
								</h6>
							}
								
						</div>

					</div>

					

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}